import React from "react"
import { Box, Button, Chip, Dialog, DialogActions, DialogContent, DialogTitle, Divider, Stack, Typography } from "@mui/material"

import { CHANGELOG_ENTRIES, CHANGELOG_VERSION, ChangelogEntry } from "@/constants/changelog"

type ChangelogDialogProps = { open: boolean; onClose: () => void }

const TYPE_LABEL: Record<ChangelogEntry["type"], string> = { feature: "Feature", improvement: "Improvement", fix: "Fix" }

const TYPE_COLOR: Record<ChangelogEntry["type"], string> = { feature: "#2563eb", improvement: "#0f766e", fix: "#ca8a04" }

export function ChangelogDialog({ open, onClose }: ChangelogDialogProps) {
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm" aria-labelledby="changelog-dialog-title">
      <DialogTitle id="changelog-dialog-title" sx={{ pb: 1.5 }}>
        <Typography variant="h6" fontWeight={600}>
          What&apos;s new
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Release {CHANGELOG_VERSION}
        </Typography>
      </DialogTitle>
      <DialogContent dividers sx={{ px: 3, py: 2 }}>
        <Stack spacing={2.5}>
          {CHANGELOG_ENTRIES.map((entry, index) => (
            <Box key={entry.id}>
              <Stack direction="row" spacing={1.5} alignItems="center" sx={{ mb: 0.75 }}>
                <Chip
                  label={TYPE_LABEL[entry.type]}
                  size="small"
                  sx={{ fontWeight: 600, color: "#fff", backgroundColor: TYPE_COLOR[entry.type] }}
                />
                <Typography variant="subtitle1" fontWeight={600}>
                  {entry.title}
                </Typography>
              </Stack>
              <Typography variant="body2" color="text.secondary">
                {entry.description}
              </Typography>
              {index < CHANGELOG_ENTRIES.length - 1 && <Divider sx={{ mt: 1.75 }} />}
            </Box>
          ))}
        </Stack>
      </DialogContent>
      <DialogActions sx={{ px: 3, py: 2 }}>
        <Button variant="contained" onClick={onClose} fullWidth>
          Got it
        </Button>
      </DialogActions>
    </Dialog>
  )
}
